// Shared data-testid registry
export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  shop: "nav-shop",
  modules: "nav-modules",
  books: "nav-books",
  b2b: "nav-b2b",
  manifesto: "nav-manifesto",
  quoteCta: "nav-quote-cta",
  dashboard: "nav-dashboard",
};

export const HERO = {
  section: "hero-section",
  headline: "hero-headline",
  ctaModules: "hero-cta-modules",
  ctaB2b: "hero-cta-b2b",
};

export const MODULES = {
  grid: "modules-grid",
  card: (id) => `module-card-${id}`,
  buyBtn: (id) => `module-buy-${id}`,
};

export const BOOKS = {
  grid: "books-grid",
  card: (id) => `book-card-${id}`,
  buyBtn: (id) => `book-buy-${id}`,
};

export const B2B = {
  section: "b2b-section",
  pricingStarter: "b2b-pricing-starter",
  pricingTeam: "b2b-pricing-team",
  pricingEnterprise: "b2b-pricing-enterprise",
  form: "b2b-quote-form",
  company: "b2b-company",
  contact: "b2b-contact",
  email: "b2b-email",
  size: "b2b-size",
  industry: "b2b-industry",
  tier: "b2b-tier",
  interestBooks: "b2b-interest-books",
  interestModules: "b2b-interest-modules",
  interestWorkshops: "b2b-interest-workshops",
  message: "b2b-message",
  submit: "b2b-submit",
};

export const FOOTER = {
  section: "footer-section",
  newsletter: "footer-newsletter-input",
  subscribe: "footer-newsletter-submit",
};

export const HOME = { emergentLink: "emergent-link" };
